/**
 * The name of the bundled audio file which will be played for the incoming chat
 * message sound.
 *
 * @type {string}
 */
export const INCOMING_MSG_SOUND_FILE = 'incomingMessage.mp3';
